import React from 'react';
import Icon from '../../../../../components/common/Icon/Icon';
import styles from './InsightBanner.module.css';

export type InsightBannerTone = 'info' | 'warning';

interface InsightBannerProps {
  tone?: InsightBannerTone;
  title?: string;
  children: React.ReactNode;
}

const ICON_BY_TONE: Record<InsightBannerTone, string> = {
  info: 'lightbulb',
  warning: 'error',
};

/**
 * "Leitura rápida" style banner for each tab. Two tones (info/warning) mirror
 * the mock's two variants without hardcoding gradient colors in components.
 */
const InsightBanner: React.FC<InsightBannerProps> = ({ tone = 'info', title, children }) => (
  <div className={`${styles.banner} ${styles[tone]}`}>
    <div className={styles.iconBox}>
      <Icon name={ICON_BY_TONE[tone]} size={20} />
    </div>
    <div className={styles.body}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.content}>{children}</div>
    </div>
  </div>
);

export default InsightBanner;
